import { mxgraphInstance } from './mxgraphFactory';
/**
 * Util
 */
export var mxAbstractCanvas2D = mxgraphInstance.mxAbstractCanvas2D;
export var mxAnimation = mxgraphInstance.mxAnimation;
export var mxAutoSaveManager = mxgraphInstance.mxAutoSaveManager;
export var mxClipboard = mxgraphInstance.mxClipboard;
export var mxConstants = mxgraphInstance.mxConstants;
export var mxDictionary = mxgraphInstance.mxDictionary;
export var mxDivResizer = mxgraphInstance.mxDivResizer;
export var mxDragSource = mxgraphInstance.mxDragSource;
export var mxEffects = mxgraphInstance.mxEffects;
export var mxEvent = mxgraphInstance.mxEvent;
export var mxEventObject = mxgraphInstance.mxEventObject;
export var mxEventSource = mxgraphInstance.mxEventSource;
export var mxForm = mxgraphInstance.mxForm;
export var mxGuide = mxgraphInstance.mxGuide;
export var mxImage = mxgraphInstance.mxImage;
export var mxImageBundle = mxgraphInstance.mxImageBundle;
export var mxImageExport = mxgraphInstance.mxImageExport;
export var mxLog = mxgraphInstance.mxLog;
export var mxMorphing = mxgraphInstance.mxMorphing;
export var mxMouseEvent = mxgraphInstance.mxMouseEvent;
export var mxObjectIdentity = mxgraphInstance.mxObjectIdentity;
export var mxPanningManager = mxgraphInstance.mxPanningManager;
export var mxPoint = mxgraphInstance.mxPoint;
export var mxPopupMenu = mxgraphInstance.mxPopupMenu;
export var mxRectangle = mxgraphInstance.mxRectangle;
export var mxResources = mxgraphInstance.mxResources;
export var mxSvgCanvas2D = mxgraphInstance.mxSvgCanvas2D;
export var mxToolbar = mxgraphInstance.mxToolbar;
export var mxUndoableEdit = mxgraphInstance.mxUndoableEdit;
export var mxUndoManager = mxgraphInstance.mxUndoManager;
export var mxUrlConverter = mxgraphInstance.mxUrlConverter;
export var mxUtils = mxgraphInstance.mxUtils;
export var mxVmlCanvas2D = mxgraphInstance.mxVmlCanvas2D;
export var mxWindow = mxgraphInstance.mxWindow;
export var mxXmlCanvas2D = mxgraphInstance.mxXmlCanvas2D;
export var mxXmlRequest = mxgraphInstance.mxXmlRequest;
//# sourceMappingURL=Util.js.map